import { createElement, type ReactNode } from 'react';
import { Link } from 'react-router-dom';

function AuthLink({ href, className, children }: { href: string; className?: string; children: ReactNode }) {
  const url = new URL(href, window.location.origin);
  let to = `${url.pathname}${url.search}`;

  if (url.pathname === '/register') to = '/login?view=register';
  if (url.pathname === '/forgotpassword') to = '/login?view=forgot-password';
  if (url.pathname === '/login' && new URLSearchParams(window.location.search).has('view')) to = '/login';

  return createElement(Link, { to, className }, children);
}

export const authUIConfig = {
  Link: AuthLink,
  basePath: '',
  redirectTo: '/dashboard',
  credentials: {
    forgotPassword: true,
  },
  emailVerification: {
    otp: true,
  },
  localization: {
    EMAIL_PLACEHOLDER: ' ',
    PASSWORD_PLACEHOLDER: ' ',
    CONFIRM_PASSWORD_PLACEHOLDER: ' ',
    SIGN_IN: 'Login',
    SIGN_UP: 'Register',
    SIGN_IN_DESCRIPTION: '',
    SIGN_UP_DESCRIPTION: '',
  },
  viewPaths: {
    SIGN_IN: 'login',
    SIGN_UP: 'register',
    EMAIL_VERIFICATION: 'register/verify',
    FORGOT_PASSWORD: 'forgotpassword',
    RESET_PASSWORD: 'resetpassword',
  },
};
